function r(r,n,a,c){r._m(n);var d=a("87c0a967");r._(n,"OrderInfoSlider",d);}